import { InternalVueConstructor } from "../../types/vue/vueConstructor";
import { createAppWithRootComponent } from "../core/vueHelpers";
import LabeledDataList, { LabeledDataListContext, LabeledDataListProps } from "./components/LabeledDataList";

const LabeledDataListConstructor: InternalVueConstructor<LabeledDataListContext> =
{
    buildVue: function (context)
    {
        const props: LabeledDataListProps =
        {
            container: context.container,
            isMobile: context.isMobile,
            ...(context.props as Record<string, unknown>)
        };

        return createAppWithRootComponent(LabeledDataList, props)
            .mount(context.container);
    }
};

export default LabeledDataListConstructor;
